import { Component, OnInit,  ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { tap , take } from 'rxjs/operators';

import { RoutingService, OccEndpointsService, TranslationService,  GlobalMessageService, GlobalMessageType } from '@spartacus/core';
@Component({
    selector: 'app-custom-statistic-display',
    templateUrl: './custom-statistic-display.component.html',
    styleUrls: ['./custom-statistic-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class CustomStatisticDisplayComponent implements OnInit {

  public downloadUrl: any;
  public pdfLoaded: boolean=false;

  constructor(
    protected routing: RoutingService,
    private httpClient: HttpClient,
    private endpoints: OccEndpointsService,
    private translation: TranslationService,
    private messageService: GlobalMessageService, 
    private sanitizer: DomSanitizer,
    private changeDetector: ChangeDetectorRef   
  ) {}

  ngOnInit(): void {
    this.openPdf();
   }

  openPdf(): void {
        const params = {
            name: 'current.pdf',
            };
          const url = this.endpoints.buildUrl('statisticPdf', {queryParams: params});
          this.httpClient
            .get(url, { observe: 'body', responseType: 'arraybuffer' })
            .pipe(
              tap(
                (data) => {
                   var file = new Blob([data], { type: 'application/pdf' })
                   this.downloadUrl =  URL.createObjectURL(file);
                   this.pdfLoaded=true;
                   this.changeDetector.detectChanges();
                }, 
                () => {
                  this.translation
                    .translate('statistic.errorExportPdf')
                    .pipe(take(1))
                    .subscribe((message) => {
                      this.messageService.add(
                        message,
                        GlobalMessageType.MSG_TYPE_ERROR
                      );
                    });
                }
              )
            )
            .subscribe((res) => {});     
      }

      pdfUrl() {
        if (this.pdfLoaded) {
          return this.sanitizer.bypassSecurityTrustResourceUrl(this.downloadUrl);
        }   
      }

}
